/**
 * Created by Jerker Nord on 2016-04-13.
 * Refactored by Ning Jiang on 2016-12-6.
 */

import {ReelEngine} from "@nolimitcity/slot-game/bin/core/engines/reel/engine/ReelEngine";
import {Linear, Timeline, TimelineMax, TweenLite} from "gsap";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {WarriorGraveyardGameModuleConfig} from "../WarriorGraveyardGameModuleConfig";

export class NudgeEvents {
    public static readonly REEL_NUDGE_STEP_COMPLETED: string = "nudgeEvent_reel_nudge_step_completed";
}

export class WGEnginePlayer extends ReelEngine {
    static _noWin: Boolean = false;
    get noWin(): Boolean {
        return WGEnginePlayer._noWin;
    }

    static set noWin(value: Boolean) {
        WGEnginePlayer._noWin = value;
    }

    public Stop(quickStop: boolean): Timeline {
        const stopTl: TimelineMax = new TimelineMax({
            paused: true,
            onComplete: () => this.onSpinStopCompleted()
        });

        this.duration = this.configDuration.SPIN;
        for (let i: number = 0; i < this.Steps; i++) {
            stopTl.fromTo(this, this.duration, {yPos: 0}, {
                ease: Linear.easeNone,
                yPos: this.stepDistance,
            });
            stopTl.add(() => this.callbacks.onCompletedStepCallback());
        }

        this.duration = quickStop ? this.configDuration.QUICK_STOP : this.configDuration.STOP;
        let ease: any = quickStop ? this.configEase.QUICK_STOP : this.configEase.STOP;

        stopTl.add(() => this.callbacks.onStopCallback());
        stopTl.fromTo(this, this.duration, {yPos: 0}, {
            ease: ease,
            yPos: this.stepDistance
        });
        stopTl.add(() => this.onBounce(), "-=" + (this.duration * 0.8));

        // Remove if we have created an normal stop first.
        this.nextTimeline = stopTl;
        return this.nextTimeline;
    }

    /**
     * main aim of this function to return timeline of nudge, do some before nudge stuff.
     * so there will be no error when i play it super fast
     */
    public onGameNudgeCompleted(): void {
        this.yPos = 0;
        this.Steps--;
        this.callbacks.onCompletedNudgeCallback!();
    }

    /**
     * override this function to play with timing if there is no win in case of wild.
     * change name to get reelId as argument
     * @constructor
     */
    public gameNudge(reelId: number): TimelineMax {
        this.duration = <number>(this.configDuration.NUDGE ? this.configDuration.NUDGE : this.configDuration.START);
        if (this.noWin) { // added this check to make quick nudge if nowin is true. (to handle wild case)
            this.duration /= 2;
        }
        this.nextTimeline = new TimelineMax();
        if (!this._reverse) {
            this.nextTimeline.add(() => {
                const wildFireAnim: PIXI.spine.Spine = WarriorGraveyardGameModuleConfig.anticipationAnimation._wildLandinAnimation[reelId - 1];
                const wildFire_YPos: number = wildFireAnim.y;
                TweenLite.fromTo(wildFireAnim, this.duration, {y: wildFire_YPos}, {
                    ease: this.configEase.NUDGE ? this.configEase.NUDGE : this.configEase.START,
                    y: wildFire_YPos + this.stepDistance,
                    onComplete: () => {
                    }
                });
            });
        }

        this.nextTimeline.fromTo(this, this.duration, {yPos: 0}, {
            ease: this.configEase.NUDGE ? this.configEase.NUDGE : this.configEase.START,
            yPos: this.stepDistance,
            onComplete: () => {
                this.yPos = 0;
                this._steps = this._steps > 0 ? this._steps - 1 : this._steps + 1;
                this.multiplierAnimationOnSymbol(reelId);
                this.onGameNudgeCompleted();
            }
        });


        return this.nextTimeline;
    }

    /**
     * function to fire event when 1 nudge step is completed
     * @param reelId
     */
    private multiplierAnimationOnSymbol(reelId: number): void {
        EventHandler.dispatchEvent(new GameEvent(NudgeEvents.REEL_NUDGE_STEP_COMPLETED, reelId));
    }
}